import React, { useState, useEffect, useContext } from "react";
import { Icon, Button, Form, Input } from "semantic-ui-react";
import { createUser } from "../../../../constants";
import { useToasts } from "react-toast-notifications";
import "./mdl-create-customer.css";
import { AppContext } from "../../../../Context/AppContext";

export default function MDL_CREATE_CUSTOMER({
  page,
  limit,
  set_mdl_open,
  update_users_list,
}) {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const { userInfo, validateTextField, appVersion, isAppVersionOutdated } =
    useContext(AppContext);
  const [var_customer_info, set_customer_info] = useState();
  const [errors] = useState([]);
  const [user, setUser] = userInfo;
  const [isLoading, setLoading] = useState();
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const { addToast } = useToasts();

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {}, []);

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/
  const onChangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "email") {
      var pattern_email = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
      );
      if (!pattern_email.test(value)) {
        errors["email"] = "Please enter valid email address.";
      } else {
        errors["email"] = null;
      }
    } else if (name === "contact_number") {
      var pattern = new RegExp(/^[0-9\b]+$/);
      if (!pattern.test(value)) {
        errors["contact_number"] = "Please enter only number.";
      } else if (value.length < 11) {
        errors["contact_number"] = "Please enter valid phone number.";
      } else {
        errors["contact_number"] = null;
      }
    } else if (name === "first_name") {
      if (validateTextField(value) === false) {
        errors["first_name"] = "Please enter valid first name.";
      } else {
        errors["first_name"] = null;
      }
    } else if (name === "last_name") {
      if (validateTextField(value) === false) {
        errors["last_name"] = "Please enter valid last name.";
      } else {
        errors["last_name"] = null;
      }
    }

    set_customer_info({ ...var_customer_info, [name]: value });
  };

  const postCustomerData = async (e) => {
    e.preventDefault();
    const { first_name, last_name, address, contact_number, email, company } =
      var_customer_info;
    if (errors["first_name"]) {
      errors["first_name"] = "Please add valid first name.";
    } else if (errors["last_name"]) {
      errors["last_name"] = "Please add valid last name.";
    } else if (errors["email"]) {
      errors["email"] = "Please add valid email.";
    } else if (errors["contact_number"]) {
      errors["contact_number"] = "Please add valid number.";
    } else {
      setLoading(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + user.token,
          entityid: user.uuid,
          appversion: var_app_version,
        },
        body: JSON.stringify({
          first_name,
          last_name,
          address,
          password: "123456789",
          contact_number,
          email,
          is_role: 0,
          company,
        }),
      };
      await fetch(createUser, requestOptions)
        .then((response) => response.json())
        .then((res) => {
          setLoading(false);
          set_mdl_open(false);
          if (res.code && res.code === 401) {
            addToast("Session expired. Please Login again.", {
              appearance: "error",
              autoDismiss: true,
            });
            //SessionExpire();
            localStorage.removeItem("user");
            setUser(null);
          } else {
            if (res.statusCode === 200) {
              addToast(res.body.success, {
                appearance: "success",
                autoDismiss: true,
              });
              update_users_list(page, limit);
            } else {
              if (res?.version && res?.version !== var_app_version) {
                set_is_app_version_outdated(true);
              }
              addToast(res.body.success, {
                appearance: "error",
                autoDismiss: true,
              });
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  /* RENDER APP
	---------------------------------------------------------------------------------*/
  return (
    <>
      <Form method="POST" onSubmit={postCustomerData} loading={isLoading}>
        <div className="modal-header">
          <div className="modal-header-title">Add Customer</div>
          <div
            className="modal-header-close"
            onClick={() => set_mdl_open(false)}
          >
            <Icon name="times circle outline" />
          </div>
        </div>
        <div className="modal-content">
          <Form.Group>
            <Form.Field
              id="first_name"
              required={true}
              name="first_name"
              label="First Name"
              control={Input}
              onChange={onChangeInput}
              error={errors["first_name"]}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="last_name"
              name="last_name"
              label="Last Name"
              required={true}
              control={Input}
              onChange={onChangeInput}
              error={errors["last_name"]}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="email"
              name="email"
              label="Email"
              required={true}
              type="email"
              control={Input}
              error={errors["email"]}
              onChange={onChangeInput}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="company"
              name="company"
              label="Company"
              required={true}
              control={Input}
              onChange={onChangeInput}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="contact_number"
              name="contact_number"
              label="Contact Number"
              required={true}
              type="tel"
              error={errors["contact_number"]}
              control={Input}
              onChange={onChangeInput}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field
              id="address"
              name="address"
              label="Address"
              required={true}
              control={Input}
              onChange={onChangeInput}
            />
          </Form.Group>
        </div>

        <div className="modal-footer">
          <Button type="submit" color="red">
            Add Customer
          </Button>
        </div>
      </Form>
    </>
  );
}
